import GameConfig from '../game/GameConfig';
import {markerTintForPlayerIndex} from './player-colors';
import GameUtils from 'src/game/GameUtils';
import * as PIXI from 'pixi.js';
import {Game, PlayerState} from 'src/game/Game';
import {Countdown} from 'src/game/Countdown';

import Container = PIXI.Container;
import Graphics = PIXI.Graphics;
import Sprite = PIXI.Sprite;

const nameBreak = 30;
const textSize = 24;

class HudRenderer {
    private uiContainer: Container;
    private playerNames: Container[] = [];
    private playerNameStrikethroughs: Graphics[] = [];
    private playerNameContainers: Container[] = [];

    private countdown?: Countdown;

    public setup(uiContainer: Container): void {
        this.uiContainer = uiContainer;
    }

    public startGame(game: Game): void {
        // Show the player names
        let x = 0;
        const y = window.innerHeight - textSize * 2;
        game.players.forEach(player => {
            const startX = x;

            const texture = GameUtils.spriteTexture('cannonball');
            const dot = new Sprite(texture);
            dot.scale.set(0.5, 0.5);
            dot.position.set(x, 0);
            dot.tint = markerTintForPlayerIndex(player.index);
            x += GameConfig.tileSize * 1.25;

            const style = new PIXI.TextStyle({
                fontFamily: 'Arial',
                fontSize: textSize,
                fill: 0xffffff,
            });
            const text = new PIXI.Text(player.name, style);
            text.position.set(x, 0);
            const metrics = PIXI.TextMetrics.measureText(player.name, style, false);
            x += metrics.width;

            const strike = new Graphics();
            strike.position.set(startX, textSize / 2);
            strike
                .lineStyle(4, 0xffffff)
                .moveTo(0, 0)
                .lineTo(x - startX, 0);
            strike.visible = false;
            this.playerNameStrikethroughs[player.index] = strike;

            x += nameBreak;

            const textContainer = new Container();
            textContainer.position.y = y;
            textContainer.addChild(dot);
            textContainer.addChild(text);
            textContainer.addChild(strike);
            this.playerNameContainers.push(textContainer);

            this.uiContainer.addChild(textContainer);
            this.playerNames.push(textContainer);
        });
    }

    public killPlayer(player: PlayerState): void {
        this.playerNameStrikethroughs[player.index].visible = true;
    }

    public endGame(): void {
        this.playerNames.forEach(text => {
            this.uiContainer.removeChild(text);
        });
        this.playerNames = [];
        this.playerNameContainers = [];
    }

    public reflow(width: number, height: number): void {
        const y = window.innerHeight - textSize * 2;
        this.playerNameContainers.forEach(container => {
            container.position.y = y;
        });
        if (this.countdown) {
            this.countdown.reflow(width, height);
        }
    }

    public setCountdown(countdown: Countdown): void {
        this.countdown = countdown;
    }

    public clearCountdown(): void {
        this.countdown = undefined;
    }
}

export default new HudRenderer();



// WEBPACK FOOTER //
// ./src/Pixi/HudRenderer.ts